import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
});


class ArticulosMultiplosRequest {
    /**
     * Llamada el endpoint de django para obtener los articulos configurados
     * con diferentes unidades de medida para pedido y barras
     * en la BD
     * @param: nada
     * @return: Una lista de artículos pedido y barras.
     */
    static ListarArticulosMultiplos(filtros) {
        return middleware.hasAuth(() => request.get(`api/articulos/multiplos/`, {
            params: {
                filtro: filtros.filtro,
                page: filtros.page
            }
        }))
    }


    /**
     * Llamada el endpoint de django para configurar el centro suministrador del drive
     * @param: value. id de la notificación
     * @param: data. una lista de objetos que contiene datos de la notificación
     * @return: Mensaje de éxito o error.
     */
    static editarConfArticulosMult(value, data){
        if (value === null) {
            return middleware.hasAuth(() => request.post(`api/articulos/multiplos/`, data));
        }
        else {
            return middleware.hasAuth(() => request.put(`api/articulos/multiplos/?id=${value}`, data));
        }
    }

    static eliminarConfArticulosMult(value){
        return middleware.hasAuth(() => request.delete(`api/articulos/multiplos/delete/${value}/`));
    }

}

export default ArticulosMultiplosRequest;